export default __webpack_public_path__ + "static/media/award2.a14cbc59.png";